class Survey {
	id = null;
	planned_course_id = null;
	creation_date = null;
	completion_date = null;
	remark = null;
	course_rating = null;
	course_rating_explaination = null;
	office_rating = null;
	office_rating_explaination = null;
	teachers = [];

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Survey;
